import React from 'react';
import Nbsp from '../components/Nbsp';

class FileDeleteButton extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="row">
                <div className="col-xs-12">
                    <button type="button" className="btn btn-danger btn-xs remove-files"
                            onClick={(e) => this.props.deleteFiles(e)}>
                        <span className="glyphicon glyphicon-trash" aria-hidden="true"></span>
                        <Nbsp/>
                        Удалить выбранные файлы
                    </button>
                </div>
            </div>
        );
    }
}
export default FileDeleteButton;